import React, {FC, Fragment} from 'react';
import {connect} from "react-redux";
import WrapperPreloader from "../../components/WrapperPreloader";
import MixerNow from "../../components/Mixer/MixerNow";
import EmptyMixer from "../../components/Mixer/EmptyMixer";
import {getResultMixer, removeMix} from '../../modules/TastesBrand';
import MixerNowHeader from "../../components/Mixer/MixerNow/MixerNowHeader";

interface IMixerNowPage {
    tastes: Array<number>,
    getResultMixer: any,
    removeMix: any
}

const MixerNowPage: FC<IMixerNowPage> = ({
                                             tastes,
                                             getResultMixer,
                                             removeMix
                                         }) => {
    return (
        <WrapperPreloader
            isLoading={false}
        >
            <Fragment>
                <MixerNowHeader/>
                {
                    tastes.length
                        ? <MixerNow
                            tobaccoList={tastes}
                            getResultMixer={getResultMixer}
                            removeMix={removeMix}
                        />
                        : <EmptyMixer/>
                }
            </Fragment>
        </WrapperPreloader>
    )
};

const mapStateToProps = (state: any) => ({
    tastes: state.tastesBrand.tastes
});

const mapDispatchToProps = (dispatch: any) => ({
    getResultMixer: () => dispatch((getResultMixer())),
    removeMix: (id: number) => dispatch((removeMix(id))),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MixerNowPage)

